import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { observer } from "mobx-react";
import _pick from "lodash/pick";
import cn from "classnames";

import { useLocale } from "src/providers/LocaleProvider";
import useStores from "src/hooks/useStores";

import { EUserSettigs } from "../../type/type";

import SwitchSettingItem from "./SwitchSettingItem";
import { useStyles } from "./styles";

const SoundSettings = () => {
    const styles = useStyles();
    const { authStore } = useStores();
    const {
        profile: {
            gameSettings: {
                form: { diceSound, notificationSound, moveSound },
            },
        },
    } = useLocale();

    const currentUser = authStore.currentUser;

    const [isFirstRender, setFirstRender] = useState(true);

    // const [gameSettings, setGameSettings] = useState(() => {
    //     return _pick(currentUser?.settings, [
    //         "pieceSound",
    //         "sound",
    //         "diceSound",
    //     ]);
    // });

    // const handleSwitchChange = (key: string) => {
    //     setGameSettings((prev) => {
    //         return { ...prev, [key]: !prev[key] };
    //     });
    // };

    const [gameSettings, setGameSettings] = useState({
        pieceSound: localStorage.getItem("pieceSound") === "true",
        noteSound: localStorage.getItem("noteSound") === "true",
        diceSound: localStorage.getItem("diceSound") === "true",
    });

    useEffect(() => {
        if (isFirstRender) {
            setFirstRender(false);
            return;
        }
        authStore.updateGameSettings(gameSettings);
    }, [gameSettings]);

    const handleSwitchChange = (setting) => {
        const updatedSettings = {
            ...gameSettings,
            [setting]: !gameSettings[setting],
        };
        setGameSettings(updatedSettings);
        localStorage.setItem(setting, updatedSettings[setting].toString());
    };

    if (!currentUser) return null;

    return (
        <Box className={cn(styles.wrapper, EUserSettigs.SOUND_ENG)}>
            <Box className={styles.groupBox}>
                <SwitchSettingItem
                    text={moveSound("Running Sound")}
                    isChecked={Boolean(gameSettings.pieceSound)}
                    onChange={() => {
                        handleSwitchChange("pieceSound");
                    }}
                />
                <SwitchSettingItem
                    text={notificationSound("Notification Sound")}
                    isChecked={Boolean(gameSettings.noteSound)}
                    onChange={() => {
                        handleSwitchChange("noteSound");
                    }}
                />

                <SwitchSettingItem
                    text={diceSound("Dice Sound")}
                    isChecked={Boolean(gameSettings.diceSound)}
                    onChange={() => {
                        handleSwitchChange("diceSound");
                    }}
                />
            </Box>
        </Box>
    );
};

export default observer(SoundSettings);
